import { defineMessages } from "react-intl";

export const MESSAGES = defineMessages({
  softCreditCheckTitle: {
    id: "funding-application: soft credit check",
    defaultMessage: "Soft credit check",
  },
  creditCheckConsentHeading: {
    id: "funding-application: credit check consent heading",
    defaultMessage: "Majority owner soft credit check",
  },
  firstNameLabel: {
    id: "funding-application: first name input label",
    defaultMessage: "First name",
  },
  firstNameError: {
    id: "funding-application: first name required",
    defaultMessage: "First name required",
  },
  lastNameLabel: {
    id: "funding-application: last name input label",
    defaultMessage: "Last name",
  },
  lastNameError: {
    id: "funding-application: last name required",
    defaultMessage: "Last name required",
  },
  dateOfBirthLabel: {
    id: "funding-application: date of birth label",
    defaultMessage: "Date of birth",
  },
  dateOfBirthError: {
    id: "funding-application: date of birth required",
    defaultMessage: "Date of birth required",
  },
  dateOfBirthInvalidError: {
    id: "funding-application: date of birth invalid",
    defaultMessage: "Please enter a valid date",
  },
  ssnLabel: {
    id: "funding-application: ssn input label",
    defaultMessage: "Social Security Number (SSN)",
  },
  ssnError: {
    id: "funding-application: ssn required",
    defaultMessage: "Social security number required",
  },
  ssnFormatError: {
    id: "funding-application: ssn format error",
    defaultMessage: "SSN format must be 9 digits XXX-XX-XXXX",
  },
  noSsnText: {
    id: "funding-application: no ssn text",
    defaultMessage: "Don't have a US Social Security Number?",
  },
  noSsnLabel: {
    id: "funding-application: no ssn checkbox label",
    defaultMessage: "I do not have a SSN",
  },
  ssnHelperText: {
    id: "funding-application: cleared ssn helper text",
    defaultMessage: "For your security, we've cleared your SSN. Please re-enter to continue.",
  },
  addressLabel: {
    id: "funding-application: address label",
    defaultMessage: "Residential address",
  },
  addressPlaceholder: {
    id: "funding-application: address placeholder",
    defaultMessage: "Start typing address",
  },
  addressError: {
    id: "funding-application: address required",
    defaultMessage: "Address required",
  },
  enterManuallyLabel: {
    id: "funding-application: enter manually label",
    defaultMessage: "Enter manually",
  },
  consentText: {
    id: "funding-application: consent text",
    defaultMessage:
      "By clicking the “I agree and submit” button, you provide written instructions to Wayflyer under the Fair Credit Reporting Act authorizing us to obtain information from your personal credit report and other data from Experian. This information will be used solely to evaluate your eligibility for business financing. <link>View details</link>",
  },
  agreeAndContinueText: {
    id: "funding-application: agree and continue text",
    defaultMessage:
      "By clicking the “I agree and continue” button, you provide written instructions to Wayflyer under the Fair Credit Reporting Act authorizing us to obtain information from your personal credit report and other data from Experian. This information will be used solely to evaluate the company's eligibility for business financing. <link>View details</link>",
  },
  agreeButtonLabel: {
    id: "funding-application: agree button label",
    defaultMessage: "I agree and submit",
  },
  infoText: {
    id: "funding-application: info text",
    defaultMessage: "This <bold>will not</bold> affect your credit score. <link>Why do we need this?</link>",
  },
  creditInfoText: {
    id: "funding-application: us credit info text",
    defaultMessage:
      "As you're based in the US, we'll run a soft credit check to build your offer. This won't affect your credit score. Please provide the Social Security Number (SSN) of an authorised officer in your business. It helps us make a faster decision and a better offer.",
  },
  consentError: {
    id: "funding-application: credit check consent required",
    defaultMessage: "You must consent to a credit check to continue",
  },
  whySoftCreditCheckRequired: {
    id: "funding-application: why soft credit check required",
    defaultMessage: "Why a soft credit check is required",
  },
  whySoftCreditCheckAnswer: {
    id: "funding-application: why soft credit check answer",
    defaultMessage:
      "We use a soft credit check to help us underwrite your business and assess eligibility for financing. <link>Learn more about soft credit check in our Help center</link>",
  },
  whyCreditCheckModalTitle: {
    id: "funding-application: why credit check modal title",
    defaultMessage: "Why a Soft Credit Check is required",
  },
  whyCreditCheckModalContent: {
    id: "funding-application: why credit check modal content",
    defaultMessage:
      "<p>We use a soft credit check to help us underwrite your business and assess eligibility for financing.</p><p>This type of check <bold>will not</bold> affect your credit score.</p>",
  },
  modalCloseButton: {
    id: "funding-application: modal close button",
    defaultMessage: "Close",
  },
  noSsnWarningTitle: {
    id: "funding-application: no ssn warning title",
    defaultMessage: "We can't offer you financing right now",
  },
  noSsnWarningContent: {
    id: "funding-application: no ssn warning content",
    defaultMessage:
      "We're currently only able to perform credit checks for individuals with a U.S. Social Security Number. We hope to support additional identification options in the future. You can <link>reach out to our support team here</link>",
  },
  backToWayflyerButton: {
    id: "funding-application: back to wayflyer button",
    defaultMessage: "Back to Wayflyer.com",
  },
  noSsnModalTitle: {
    id: "funding-application: no ssn modal title",
    defaultMessage: "Are you sure you don't have a Social Security Number?",
  },
  noSsnModalContent: {
    id: "funding-application: no ssn modal content",
    defaultMessage:
      "If you have a Social Security Number, we'll need it to process your application. Skipping this step means we'll request it later, which will delay your application.",
  },
  addSsnButton: {
    id: "funding-application: add ssn button",
    defaultMessage: "Add Social Security Number",
  },
  submitWithoutSsnButton: {
    id: "funding-application: submit without ssn button",
    defaultMessage: "Continue without",
  },
  agreeAndContinueButton: {
    id: "funding-application: agree and continue",
    defaultMessage: "Agree and continue",
  },
});

export const MODAL_CONFIGS = {
  whyCredit: {
    titleMessage: MESSAGES.whyCreditCheckModalTitle,
    contentMessage: MESSAGES.whyCreditCheckModalContent,
  },
};
